'use client'

import React from 'react'

const DateCell = ({ cellData }: { cellData: unknown }) => {
  if (!cellData) {
    return <span>—</span>
  }

  const date = new Date(cellData as string)

  // Format as dd.MM.yyyy
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  return <span>{`${day}.${month}.${year}`}</span>
}

export default DateCell

